import { Injectable } from '@angular/core';
import axios from 'src/app/Service/axios';
import { ReportContext, ReportDefinition } from '../../report.models';
import { VehicleWorkResponse, VehicleWorkError } from './vehicle-work-report.models';
@Injectable({ providedIn: 'root' })
export class VehicleWorkReportApiService {
  async load(definition: ReportDefinition, context: ReportContext, user: string, session: string): Promise<VehicleWorkResponse> {
    const response = await axios.post(`${definition.endpoint}?vstrSDate=${context.startDate}&vstrUnitID=${context.id}&vstrEDate=${context.endDate}&iSTime=${context.startTime}&iETime=${context.endTime}&iSystemUser=${user}&strSession=${encodeURIComponent(session)}`);
    return this.parse(response.data);
  }
  async recalculate(context: ReportContext, user: string, session: string): Promise<VehicleWorkResponse> {
    const numericUser = parseFloat(user.replace(/,/g, ''));
    const response = await axios.post('ReportFunctionAndDistanceMountly_ReCal', { iSystemUser: isNaN(numericUser) ? user : numericUser, strSession: session,
      strUnitID: context.id, strSDate: context.startDate, strEDate: context.endDate });
    return this.parse(response.data);
  }
  private parse(raw: unknown): VehicleWorkResponse {
    const data = typeof raw === 'string' ? JSON.parse(raw) : raw;
    if (Array.isArray(data)) return data;
    if (data && typeof data === 'object') {
      const result = data as VehicleWorkError;
      if (result.ISSessionExpired || result.ISessionExpired || result.bError) return result;
    }
    throw new Error('Unexpected work report response');
  }
}
